import { FC, useMemo } from "react"

// components
import FeaturedArticles from "../../FeaturedArticles/FeaturedArticles"
import TopicSection from "../../BrowseByTopicSection/TopicSection"

// utils
import { getPanelId, getTabId } from "./Tabs"

// styles
import { topicSectionWrapper } from "../../../pages/{ContentfulHelpArticle.node_locale}/index.module.scss"

type HelpCenterHomePage = NonNullable<
  Queries.HomepageDataQuery["helpCenterHomePage"]
>

type Props = {
  segment: HelpCenterHomePage["attendee"] | HelpCenterHomePage["organizer"]
  prefixedBasePath: string
}

export const TabContent: FC<Props> = ({ segment, prefixedBasePath }) => {
  const articleContent = useMemo(() => {
    return segment?.content?.[0] ?? null
  }, [segment])

  const topicContent = useMemo(() => {
    return segment?.content?.[1] ?? null
  }, [segment])

  return (
    <>
      <div
        id={getPanelId(segment?.title ?? "")
          .split(" ")
          .join("")}
        role="region"
        aria-live="polite"
        aria-labelledby={getTabId(segment?.title ?? "")
          .split(" ")
          .join("")}
      >
        <FeaturedArticles
          content={articleContent}
          prefixedBasePath={prefixedBasePath}
        />
      </div>
      <div className={topicSectionWrapper}>
        <TopicSection
          content={topicContent}
          prefixedBasePath={prefixedBasePath}
        />
      </div>
    </>
  )
}
